import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OptionTelechargementPlusieursPdfs } from '@lexi-clients/lexi';

@Injectable({ providedIn: 'root' })
export class DownloadService {

    constructor() {
    }

    public getOptionsTelechargementPdfs(): {id: OptionTelechargementPlusieursPdfs, libelle: string}[] {
        return [
            { id: OptionTelechargementPlusieursPdfs.pdf, libelle: "Dans un seul PDF" },
            { id: OptionTelechargementPlusieursPdfs.zip, libelle: "Dans un fichier .zip" }
        ];
    }

    public directDownloadFile(response: HttpResponse<Blob>, extensionFichier: string = null) {
        const headerValue = response.headers.getAll("Content-disposition")[0];

        const index1 = headerValue.indexOf("filename=") + 9;
        const indexExtension = headerValue.indexOf(`${extensionFichier};`);
        const indexPointVirgule = headerValue.indexOf(`;`, index1);
        const index2 = indexExtension < 0 ? indexPointVirgule : Math.min(indexExtension, indexPointVirgule);
        const filenameFromHeader = headerValue.slice(index1, index2);
        
        // Déterminer l'extension à utiliser
        let extensionToUse = extensionFichier;
        
        if (!extensionToUse && !filenameFromHeader.includes('.')) {
            // Si pas d'extension fournie et pas d'extension dans le nom, on détermine depuis le Content-Type
            switch(response.headers.get("Content-Type")) {
                case 'application/pdf':
                    extensionToUse = 'pdf';
                    break;
                case 'application/zip':
                    extensionToUse = 'zip';
                    break;
                case 'text/csv':
                    extensionToUse = 'csv';
                    break;
                default:
                    break;
            }
        }
        
        // Vérifier si le nom contient déjà l'extension
        const hasExtension = extensionToUse ? 
            filenameFromHeader.toLowerCase().endsWith(`.${extensionToUse.toLowerCase()}`) :
            filenameFromHeader.includes('.');

        // Construire le nom final
        const filename = filenameFromHeader + (!hasExtension && extensionToUse ? `.${extensionToUse}` : "");

        const data = response.body;
        const downloadURL = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = filename;
        link.click();
    }

    public downloadFileFromLink(link : string,fileName : string){
        const downloadElement = document.createElement('a');
        downloadElement.setAttribute('href', link);
        downloadElement.setAttribute('download', fileName);
        document.body.appendChild(downloadElement);
        downloadElement.click();
        downloadElement.remove();
    }
}
